var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapperClasses},[_c(_vm.icon,{tag:"component",staticClass:"max-h-full max-w-full",class:_vm.classes})],1)}
var staticRenderFns = []

export { render, staticRenderFns }